module.exports = __webpack_public_path__ + "img/1.4b8cca9d.png";